(function () {

    "use strict";

    /*
        self.options = [
            {
                [required] value: valid time value match time-type
                [optional] info: string ex: '3hrs 15m' ,
                [optional] icon: fontawesome class string ex: 'fa fa-user',
            },
            ...
        ];
    */

    HTimepickerComponent.$inject = ['$scope', '$timeout', '$element'];
    function HTimepickerComponent($scope, $timeout, $element) {

        var self = this;
        self.formattedTime = '';
        self.forwardedControlId = '';
        var changesBySelf = false;
        var date = '1970-01-01';
        var dateFormat = 'YYYY-MM-DD';
        var validTimeTypes = [ 'iso', 'string', 'moment', 'date'];
        var supportedTimeFormat = [];
        var hourFormats = ['H', 'HH', 'h', 'hh'];
        var minuteFormats = ['m', 'mm'];
        var amFormats = ['A', 'a'];
        var liftRightKeys = [37, 39];
        var upDownKeys = [38, 40];
        var keysMap = {
            left: 37,
            right: 39,
            up: 38,
            down: 40,
            enter: 13,
            tab: 9,
        };

        var lastValidValue = moment().startOf('day');

        var initSupportedTimeFormat = function () {
            hourFormats.forEach(function (h) {
                minuteFormats.forEach(function (m) {
                    supportedTimeFormat.push(h + ':' + m);
                    amFormats.forEach(function (a) {
                        supportedTimeFormat.push(h + ':' + m + ' ' + a);
                    })
                })
            })
        };
        initSupportedTimeFormat();

        var autoCompleteSuggestions = {};
        var autoCompletePredictions = {};
        self.$onChanges = function (changesObj) {

            if (
                changesObj.date
            ) {
                date = self.date ? self.date.format(dateFormat) : moment('1970-01-01').format(dateFormat);
            }

            if (changesObj.minuteStep) {
                self.minuteStep = self.minuteStep || 1;
            }

            if (changesObj.hourStep) {
                self.hourStep = self.hourStep || 1;
            }

            if (changesObj.timeFormat) {
                self.timeFormat = self.timeFormat || 'HH:mm';
            }

            if (changesObj.timeType) {
                validateTimeType();
            }

            if (changesObj.timeFormat) {
                validateTimeFormat();
            }

            if (
                changesObj.ngModel ||
                changesObj.timeType ||
                changesObj.timeFormat ||
                changesObj.minTime ||
                changesObj.maxTime
            ) {
                onNgModelChanges();
            }

            if (changesObj.options) {
                self.localOptionsIinited = false;
                self.localOptions = [];
                autoCompleteSuggestions = {};
                autoCompletePredictions = {};

            }

        };



        self.momentNgModel = null;
        var onNgModelChanges = function () {

            var localNgModel = null;

            if (!changesBySelf) {

                localNgModel = getMomentByType(self.ngModel);

                if (localNgModel) {
                    date = localNgModel.format(dateFormat);
                    self.formattedTime = localNgModel.format(self.timeFormat);
                    lastValidValue = localNgModel.clone();

                    if (self.minTime) {
                        var minTime = getMomentByType(self.minTime);
                        self.hasMinMaxError = minTime && minutesOfDay(localNgModel) < minutesOfDay(minTime);
                    }
                    if (self.maxTime && !self.hasMinMaxError) {
                        var maxTime = getMomentByType(self.maxTime);
                        self.hasMinMaxError = maxTime && minutesOfDay(maxTime) < minutesOfDay(localNgModel);
                    }


                }
                else {
                    self.formattedTime = '';
                    lastValidValue = moment().startOf('day');
                }

                self.momentNgModel = localNgModel;
                setSelectedOption();
                triggerForwardedControl(localNgModel);
            }

            changesBySelf = false;
        };

        var validateTimeType = function () {
            if (validTimeTypes.indexOf(self.timeType) === -1) {
                throw new Error('[time-type] required for [h-timepicker], options: ' + validTimeTypes.join(', '));
            }
        };

        var validateTimeFormat = function () {
            if (supportedTimeFormat.indexOf(self.timeFormat) === -1) {
                throw new Error(self.timeFormat + ' is invalid h-timepicker time-format');
            }
        };

        var createAutoCompletePredictions = function(formatted_value, value) {

            autoCompletePredictions[value.format('H:mm')] = formatted_value;
            autoCompletePredictions[value.format('Hmm')] = formatted_value;

            autoCompletePredictions[value.format('hmma')] = formatted_value;
            autoCompletePredictions[value.format('hhmma')] = formatted_value;

            autoCompletePredictions[value.format('h:mm a')] = formatted_value;
            autoCompletePredictions[value.format('hh:mm a')] = formatted_value;

        };

        self.formattedTimeFocused = false;
        self.localOptions = [];
        self.localOptionsIinited = false;

        self.onFormattedTimeFocus = function () {
            self.formattedTimeFocused = true;
            $scope.$emit('timePickerInputFocused', event);
            if (self.localOptionsIinited) {
                return;
            }
            if (self.options && self.options.length) {
                self.options.forEach(function (item) {
                    var id = _.uniqueId(self.forwardedControlId + '-option-');
                    var option = {
                        option: item,
                        value: item.value,
                        info: item.info,
                        icon: item.icon,
                        formatted_value: item.value.format(self.timeFormat),
                        _id: id
                    };
                    autoCompleteSuggestions[option.formatted_value] = option;
                    createAutoCompletePredictions(option.formatted_value, item.value);
                    self.localOptions.push(option);
                });
                self.localOptionsIinited = true;
                setSelectedOption();
                const selected = getSelectedOption();

                if (selected) {
                    scrollToOption(selected);
                }
                listenToShownEvent();
            }
        };

        var setSelectedOption = function () {

            if (!self.localOptionsIinited) {
                return;
            }

            self.localOptions.forEach(function (item) {
                item._selected = !!self.momentNgModel && item.value.isSame(self.momentNgModel, 'moment');
            });

            self.localOptions = angular.copy(self.localOptions);
        };

        const getSelectedOption = () => {
            if (!self.ngModel) {
                return;
            }

            const localNgModel = getMomentByType(self.ngModel);
            return self.localOptions?.find((item) => localNgModel.isSame(item.value, 'moment'));
        };

        const scrollToOption = (option, runOnNextDigest = true) => {
            const scroll = () => {
                const $container = $element.find(`#${self.optionsListId} .hui-menu-content`);
                const $scrollTo = $element.find(`#${option._id}`);

                if (!$container.length || !$scrollTo.length) {
                    return;
                }

                $container.scrollTop(
                    $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                );
            }

            if (runOnNextDigest) {
                $timeout(() => {
                    scroll();
                });
            } else {
                scroll();
            }
        };

        self.onFormattedTimeBlur = (event) => {
            $timeout(() => {
                if (!$element?.[0]?.contains?.(document.activeElement)) {
                    self.formattedTimeFocused = false;
                    $scope.$emit('timePickerInputBlured', event);
                }
            });
        };

        self.onOptionClicked = function (option, $event) {
            self.onOptionSelect({option: option.option});
            self.onFormattedTimeChange(option.formatted_value, option.value);
            self.autoComplete = null;
            self.formattedTimeFocused = false;
            changesBySelf = false;
            $scope.$emit('timePickerInputBlured', event);
        };

        self.onFormattedTimeChange = function (formattedTime, forceMomentValue) {

             var ngModel = forceMomentValue || moment(date + " " + formattedTime, dateFormat + " " + self.timeFormat, true);
             if (self.validateTime) {
                 ngModel = self.validateTime({value: ngModel});
             }
             var momentNgModel = ngModel;
             var validatedMomentNgModel = undefined;

            if (!isValidDate(ngModel.toDate())) {
                ngModel = undefined;
            }
            else {
                validatedMomentNgModel = ngModel.clone();
            }

            if (ngModel && self.minTime) {
                var minTime = getMomentByType(self.minTime);
                self.hasMinMaxError = minTime && minutesOfDay(ngModel) < minutesOfDay(minTime);

                if (!self.hasMinMaxError && self.maxTime) {
                    var maxTime = getMomentByType(self.maxTime);
                    self.hasMinMaxError = maxTime && minutesOfDay(maxTime) < minutesOfDay(ngModel);
                }

            }

            if (ngModel) {
                if (self.timeType === 'iso') {
                    ngModel = ngModel.toDate().toISOString();
                }
                else if (self.timeType === 'string') {
                    ngModel = ngModel.format(self.timeFormat);
                }
                else if (self.timeType === 'date') {
                    ngModel = ngModel.toDate();
                }
                else if (self.timeType === 'moment') {

                }

                lastValidValue = getMomentByType(ngModel);
            }

            self.onMomentModelChange({value: validatedMomentNgModel});
            self.ngModelCtrl.$setViewValue(ngModel);
            triggerForwardedControl(momentNgModel);
            changesBySelf = true;
        };

        /**
         * this method attach to the shown.bs.dropdown event from bootstrap, this event is triggered on the direct parent of the `.dropdown-menu`
         * and our `.dropdown-menu` has the unique id of self.optionsListId it will also get the child that has the class of `.hui-menu-content`
         * which is the scrollable container that contains all the elements to scroll its view so the selected element is visible.
         */
        const listenToShownEvent = () => {
            $element.off('shown.bs.dropdown').on('shown.bs.dropdown', () => {
                const selected = getSelectedOption();

                if (selected) {
                    scrollToOption(selected, false);
                }
            });
        }

        self.$onInit = function () {
            self.forwardedControlId = _.uniqueId('h-timepicker-');
            self.optionsListId = _.uniqueId('h-timepicker-options-list');
        };

        self.$onDestroy = function () {

        };

        var getTimeParts = function (validStringTime) {
            var hours = validStringTime.split(':')[0];
            var minutes = validStringTime.split(':')[1].split(' ')[0];
            var am = validStringTime.split(' ')[1];

            return {
                hours: hours,
                minutes: minutes,
                am: am,
            }
        };

        self.autoComplete = null;
        var setAutoCompleteSuggestion = function(text) {

            if (!text) {
                self.autoComplete = null;
                return;
            }

            var keys = Object.keys(autoCompleteSuggestions);
            var key = keys.find(function (item) {
                return item.startsWith(text) || item === text;
            });
            var auto_complete_text = key;

            if (!key) {
                var prediction = Object.keys(autoCompletePredictions).find(function (item) {
                    return item.startsWith(text) || item === text;
                });

                key = autoCompletePredictions[prediction];
                auto_complete_text = prediction;
            }

            if (key) {
                autoCompleteSuggestions[key].auto_complete_text = auto_complete_text;
                self.autoComplete = autoCompleteSuggestions[key];
                scrollToOption(self.autoComplete);
            }
            else {
                self.autoComplete = null;
            }
        };

        self.onKeyup = function(event) {

            var keyCode = event.keyCode;

            if (keyCode === keysMap.enter || keyCode === keysMap.tab || keyCode === keysMap.right) {
                if (self.autoComplete) {
                    if (keyCode === keysMap.enter) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    self.onOptionClicked(self.autoComplete, event);
                    self.autoComplete = null;
                }
            }
            else if(!(liftRightKeys.indexOf(keyCode) > -1 || upDownKeys.indexOf(keyCode) > -1)){
                setAutoCompleteSuggestion(event.target.value)
            }

        };

        self.onKeydown = function (event) {

            var keyCode = event.keyCode;

            if (keyCode === keysMap.tab || keyCode === keysMap.enter) {
                self.onKeyup(event);
                return;
            }

            if (!self.ngModel && keyCode === keysMap.right) {
                return;
            }

            if (liftRightKeys.indexOf(keyCode) > -1 || upDownKeys.indexOf(keyCode) > -1) {

                event.preventDefault();

                self.autoComplete = null;
                var target = event.target;
                var selectionStart = target.selectionStart;
                var selectionEnd = target.selectionEnd;
                var selections = {
                    hours: [],
                    minutes: [],
                    am: [],
                };

                var lastValidValueString = lastValidValue.format(self.timeFormat);
                self.formattedTime = lastValidValueString;

                var timeParts = getTimeParts(lastValidValueString);

                var indexOfColon = lastValidValueString.indexOf(':');
                var indexOfSpace = lastValidValueString.indexOf(' ');

                selections.hours = [0, indexOfColon];
                selections.minutes = [indexOfColon + 1, indexOfSpace];
                selections.am = [indexOfSpace + 1, lastValidValueString.length];

                if (!timeParts.am) {
                    selections.minutes = [indexOfColon + 1, lastValidValueString.length];
                    selections.am = [0, 0];
                }

                var currentSelection = '';
                if (selectionStart > indexOfSpace && timeParts.am) {
                    currentSelection = 'am';
                }
                else if (selectionStart > indexOfColon) {
                    currentSelection = 'minutes';
                }
                else {
                    currentSelection = 'hours';
                }

                var nextSelectionStartEnd = [];
                if (liftRightKeys.indexOf(keyCode) > -1) {
                    if (selectionStart === selectionEnd) {
                        nextSelectionStartEnd = selections[currentSelection];
                    }
                    else if (keyCode === keysMap.left) {
                        if (currentSelection === 'hours') {
                            nextSelectionStartEnd = timeParts.am ? selections.am : selections.minutes;
                        }
                        else if (currentSelection === 'minutes') {
                            nextSelectionStartEnd = selections.hours;
                        }
                        else if (currentSelection === 'am') {
                            nextSelectionStartEnd = selections.minutes;
                        }
                    }
                    else if (keyCode === keysMap.right) {
                        if (currentSelection === 'hours') {
                            nextSelectionStartEnd = selections.minutes;
                        }
                        else if (currentSelection === 'minutes') {
                            nextSelectionStartEnd = timeParts.am ? selections.am : selections.hours;
                        }
                        else if (currentSelection === 'am') {
                            nextSelectionStartEnd = selections.hours;
                        }
                    }
                    target.setSelectionRange(nextSelectionStartEnd[0], nextSelectionStartEnd[1]);
                }

                else if (upDownKeys.indexOf(keyCode) > -1) {

                    var newValue = lastValidValue.clone();
                    var add = 1;

                    if (keyCode === keysMap.down) {
                        add = -1;
                    }

                    if (currentSelection === 'hours') {
                        add = add * self.hourStep;
                        newValue.add(add, 'hours');
                    }
                    else if (currentSelection === 'minutes') {

                        var hour = newValue.hour();
                        var minute = newValue.minute();

                        var remainder = self.minuteStep;

                        if (minute % self.minuteStep) {
                             remainder = self.minuteStep - (minute % self.minuteStep);
                            if (add === -1) {
                                remainder = minute % self.minuteStep;
                            }
                        }
                        newValue.add(remainder * add, 'minutes');
                        newValue.hour(hour);
                    }
                    else if (currentSelection === 'am') {
                        add = add * 12;
                        newValue.add(add, 'hours');
                    }

                    var newStringValue = newValue.format(self.timeFormat);
                    var selectionStartEnd = getSelectionStartEndOf(newStringValue, currentSelection);

                    target.value = newStringValue;
                    target.setSelectionRange(selectionStartEnd.start, selectionStartEnd.end);
                    angular.element(target).triggerHandler('change');
                }

            }

        };

        var getSelectionStartEndOf = function(validTimeString, type) {

            var start = 0;
            var end = 0;
            var hasAm = validTimeString.indexOf(' ') > -1;

            if (type === 'hours') {
                end = validTimeString.indexOf(':');
            }
            else if (type === 'minutes') {
                start = validTimeString.indexOf(':') + 1;
                if (hasAm) {
                    end = validTimeString.indexOf(' ');
                }
                else {
                    end = validTimeString.length;
                }

            }
            else if (type === 'am') {
                start = validTimeString.indexOf(' ') + 1;
                end = validTimeString.length;
            }

            return {
                start: start,
                end: end,
            }
        };


        var getMomentByType = function (from) {

            var value;

            if (!from) {
                return value;
            }

            if (self.timeType === 'iso') {
                var isValidIsoTime = moment(from, moment.ISO_8601, true).isValid();
                if (isValidIsoTime) {
                    value = moment(from);
                }
            }
            else if (self.timeType === 'string') {
                var isValidStringTime = moment(date + " " + from, dateFormat + " " + self.timeFormat, true).isValid();
                if (isValidStringTime) {
                    value = moment(date + " " + from, dateFormat + " " + self.timeFormat);
                }
            }
            else if (self.timeType === 'date') {
                var isValid = moment(from, true).isValid();
                if (isValid) {
                    value = moment(from);
                }
            }
            else if (self.timeType === 'moment') {
                if (moment.isMoment(from)) {
                    value = from.clone();
                }
            }
            else {
                throw new Error('[time-type] required for [h-timepicker], options: ' + validTimeTypes.join(','));
            }

            return value;
        };


        self.hasMinMaxError = false;

        var triggerForwardedControl = function (value) {
            setTimeout(function () {
                var control = document.getElementById(self.forwardedControlId);
                if (control) {
                    control.value = (value && moment.isMoment(value) && value.isValid()) ? value.format(self.timeFormat) : '';
                    angular.element(control).triggerHandler('change');
                }
            }, 100);
        };

        var isValidDate = function(d) {
            return d instanceof Date && !isNaN(d);
        };

        var minutesOfDay = function(m){
            return m.minutes() + m.hours() * 60;
        };



    }

    var HTimepickerComponentOptions = {
        bindings: {
            name: '@',
            placeholder: '@',
            inputClass: '@',
            ngModel: "<",
            ngDisabled: "<",
            ngChange: '&',
            ngInputClass: "<",
            timeType: '@',
            timeFormat: '@',
            hourStep: '<',
            minuteStep: '<',
            minTime: '<',
            maxTime: '<',
            options: '<',
            onOptionSelect: '&',
            onMomentModelChange: '&',
            validateTime: '&?',
            appendText: '<',
            prependIcon: '<',
            date: '<',
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        controller: HTimepickerComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-timepicker/h-timepicker.component.ng.html'
    };

    angular
        .module('components')
        .component('hTimepicker', HTimepickerComponentOptions);


})();
